import { getObjectKeys } from "@gettactic/helpers/src/objects/getObjectKeys";
import { DataManColumDef } from "../types/columns";

export const buildHierarchyColumnsDefFromHierarchyData = (
  data: any[]
): DataManColumDef<unknown>[] => {
  const columns: DataManColumDef<unknown>[] = [];

  // TODO Also assign the correct renderer for each column based on the data type

  (data || []).forEach((item) => {
    const keys = getObjectKeys(item);
    for (const _key of keys) {
      const key = String(_key);
      if (!columns.find((column) => column.key === key)) {
        columns.push({
          key,
          title: key
        });
      }
    }
  });

  return columns;
};
